var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.fieldType.component || 'div',_vm._b({tag:"component",attrs:{"value":_vm.value,"error-messages":_vm.errorMessages,"return-object":""},on:{"input":args => _vm.$emit('input', args)}},'component',_vm.additionalProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }